import http from "../api";

class OrderDataService {
    getAll() {
        return http({
            'method':'GET',
            'url':'/columns'
        });
    }

    getOrdersFromCashBox(data) {
        return http({
            'url':'/orders/getOrdersFromCashBox',
            'method':'POST',
            'data': data
        });
    }
}

export default new OrderDataService();